import _ from "lodash";
import { useMemo } from "react";

import { API_ENDPOINTS } from "../../api/constants";
import useFetch from "../../api/useFetch";

/*
 * Retrieves HDFundingRound objects for the company that do not occur in the future to the
 * provided valuation date. Possibly returns undefined if there are no such objects.
 */
const useLatestFundingRound = (companyId, valuationDate, queryEnabled = false) => {
  const fundingRoundsQuery = useFetch(
    API_ENDPOINTS.FUNDING_ROUNDS(),
    {
      company: companyId,
      "page[size]": 10000,
    },
    {
      enabled: queryEnabled,
    }
  );

  return useMemo(() => {
    // Finds the HDFundingRound whose date is most recent prior to the valuation date.
    const hdFundingRounds = fundingRoundsQuery.cleanedData?.data || [];
    return [
      _.maxBy(hdFundingRounds, round =>
        round.date && new Date(round.date) <= new Date(valuationDate)
          ? new Date(round.date).getTime()
          : -1
      ),
      fundingRoundsQuery.isLoading,
    ];
  }, [fundingRoundsQuery.isLoading, valuationDate, fundingRoundsQuery.cleanedData?.data]);
};

export default useLatestFundingRound;
